<template>
  <div class="mapPopup">
    <div class="header">
      <img src="@/assets/images/icon-close3.png" style="opacity: 0;" alt="">
      <span>{{ title }}</span>
      <img src="@/assets/images/icon-close3.png" @click="mapPopupClose" alt="">
    </div>
    <div class="content">
      弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容弹窗内容
    </div>
    <!-- <img src="@/assets/images/icon-close2.png" style="background-color: red;" alt=""> -->
  </div>
</template>

<script>
export default {
  props:{
    title:{
      type:String,
      default:'默认弹窗'
    }
  },
  data() {
    return {}
  },
  mounted() {

  },
 methods:{
  mapPopupClose(){
    this.$emit('mapPopupClose')
  }
 }
}
</script>

<style lang="scss" scoped>
.mapPopup {
  position: relative;
  z-index: 1;
  width: 400px;
  background: #ffffff;
  box-shadow: 0px 4px 8px #2a334740;
  border-radius: 5px;
  padding: 20px;

  &::after {
    content: '';
    display: block;
    position: absolute;
    bottom: 0;
    left: 50%;
    z-index: 0;
    transform: translate(-50%, 50%);
    width: 0;
    height: 0;
    border-top: 15px solid #ffffff;
    border-right: 15px solid transparent;
    border-left: 15px solid transparent;
  }

  .header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;

    >img {
      cursor: pointer;
      width: 24px;
      height: 24px;
    }
  }
}</style>